
const routes = {
    LOGIN:'/login',
    DASHBOARD:'/dashboard',
    ADMIN_USERS:'/adminusers',
    CLASSIC_USERS:'/classicuser',
    CREATORS:'/creators',
    PRODUCTS:'/products',
    GIFTS:'/gifts',
    ITEMS:'/linkitems',
    SELFIES:'/selfies',
    CART:'/usercart',
    BRANDS:'/brands',
    CATEGORIES:'/categories',
    SUBCATEGORIES:'/subcategories',
    ROLES:'/role',
    CREDIT_CODES:'/creditcode',
    NOTIFICATION:'/notification',










  
}
export default routes